module.exports = __webpack_public_path__ + "img/Unicom.06d91e9f.jpg";